import { dehydrate } from '@tanstack/react-query'
import { getProps } from 'ssr/getProps'
import { runWithAmplifyServerContext, serverClient } from 'web-amplify/server'

import {
  getCategoryTagsQuery,
  getCategoryTagsQueryKey
} from '~explore/queries/useGetCategoryTags'
import {
  getPopularMapsQuery,
  getPopularMapsQueryKey
} from '~explore/queries/useGetPopularMaps'
import { Category_Tag_Type } from '~explore/types/__generated/gql/graphql'

export const getServerSideProps = getProps(async (context, client) => {
  const getPrimaryTagsVariables = {
    categoryTypes: [Category_Tag_Type.Primary],
    size: 3
  }

  const getSecondaryTagsVariables = {
    categoryTypes: [Category_Tag_Type.Secondary],
    size: 5
  }

  const [
    {
      data: { searchMaps: getPopularMaps }
    },
    {
      data: { getCategoryTags: getPrimaryTags }
    },
    {
      data: { getCategoryTags: getSecondaryTags }
    }
  ] = (await runWithAmplifyServerContext({
    nextServerContext: {
      response: context.res,
      request: context.req
    },
    operation: async (ctx) =>
      Promise.all([
        serverClient.graphql(ctx, {
          query: getPopularMapsQuery,
          variables: {}
        }),
        serverClient.graphql(ctx, {
          query: getCategoryTagsQuery,
          variables: getPrimaryTagsVariables
        }),
        serverClient.graphql(ctx, {
          query: getCategoryTagsQuery,
          variables: getSecondaryTagsVariables
        })
      ])
  })) as any

  await Promise.all([
    client.prefetchQuery({
      queryKey: getPopularMapsQueryKey(),
      queryFn: () => getPopularMaps
    }),
    client.prefetchQuery({
      queryKey: getCategoryTagsQueryKey(getPrimaryTagsVariables),
      queryFn: () => getPrimaryTags
    }),
    client.prefetchQuery({
      queryKey: getCategoryTagsQueryKey(getSecondaryTagsVariables),
      queryFn: () => getSecondaryTags
    })
  ])

  return {
    props: {
      dehydratedState: dehydrate(client)
    }
  }
})
